<mat-progress-bar class="progress-bar" [ngClass]="{ active: showLoadingBar }" [color]="errorHappened ? 'warn' : 'primary'" mode="determinate" [value]="overallProgress"></mat-progress-bar>
